import { Component, OnInit, OnDestroy, inject } from '@angular/core';
import { GlobalErrorHandler } from '../../services/globalErrorHandler';
import { Subscription } from 'rxjs';
import { APIService } from '../../services/api.service';
import { EmailLinkComponent } from '../emailLink/emailLink.component';

@Component({
  selector: 'ccf-error-alert',
  templateUrl: 'error.component.html',
  styleUrls: ['error.component.less'],
  imports: [EmailLinkComponent],
})
export class ErrorComponent implements OnInit, OnDestroy {
  protected readonly errorHandler = inject(GlobalErrorHandler);
  protected readonly apiService = inject(APIService);

  private readonly _subscriptions: Subscription[] = [];
  // TODO detect failure after refreshing

  hasErrored: boolean = false;
  hasUpdated: boolean = false;

  ngOnInit(): void {
    this._subscriptions.push(
      this.errorHandler.errorsStream().subscribe(() => {
        this.hasErrored = true;
        // TODO add more
      }),
    );

    this._subscriptions.push(
      this.apiService.statStream.subscribe((value) => {
        if (value) {
          this.hasUpdated = true;
          // TODO add more
        }
      }),
    );
  }

  ngOnDestroy(): void {
    this._subscriptions.forEach((sub) => sub.unsubscribe());
  }

  refresh(): void {
    self.location.reload();
  }

  dismiss(): void {
    this.hasUpdated = false;
  }
}
